<template>
  <div class="body mobile">
    <!-- Header -->
    <section class="header notice">
      <div class="flexH width">
        <a class="icon iconButton third" @click.prevent="$router.push('/profile')">
          <font-awesome-icon
            icon="fa-solid fa-chevron-left"
            size="lg"
          ></font-awesome-icon>
        </a>
      </div>
      <span class="fL nowrap font-bold font-white">特店管理後台</span>
      <div class="flexH width right"></div>
    </section>

    <!-- Main -->
    <section class="main notice pb">
      <div class="records flexV width padding">
        <div class="record pl-5 mt-2 mb-3 shadow-md-solid" style="background-color : var(--c002);">
          <div class="fS text-white px-4">特店一覽</div>
          <div class="dropdown rounded">
            <select class="fM rounded px-3" v-model="currentStoreId">
              <option value="0">選擇特店</option>
              <template v-if="storeList.length > 0">
                <option v-for="store in storeList" :key="store.storeId" :value="store.storeId">{{ store.name }}</option>
              </template>
            </select>
            <div class="arrow">
              <font-awesome-icon icon="fa-solid fa-caret-down" size="xs"></font-awesome-icon>
            </div>
          </div>
        </div>

        <div class="mt-3">特店資訊</div>

        <div v-if="storeData != null" class="record shadow-md mb-3" style="background-color : var(--cWhite);">
          <div class="flexH width relative mb-1">
            <div class="gap-1 mr-1">
              <div class="border-c1-md rounded img" style="width: 90px; height: 90px;">
                <img v-if="storeData.storeImageUrl != undefined && storeData.storeImageUrl != null && storeData.storeImageUrl != ''" :src="storeData.storeImageUrl" :alt="storeData.storeName" />
                <img v-else src="@/assets/img/avator_store.svg" />
              </div>
            </div>
            <div class="flexV width line-height leading-8">
              <div class="fS primary">
                <img
                  src="@/assets/icon/document.svg"
                  alt=""
                />
                <template v-if="verifyStatus == 'verified'">&nbsp;點數特約店家</template>
                <template v-else>&nbsp;一般特店</template>
              </div>
              <div>
                <div class="fL">{{ storeData.storeName }}</div>
              </div>
              <div v-if="storeData.approveStatus == 'reviewing'">
                <span class="badge-label rounded-2xl bg-grey fXS">審核中</span>
              </div>
              <div v-else-if="storeData.approveStatus == 'rejected'">
                <span class="badge-label rounded-2xl bg-grey fXS">退回</span>
              </div>
              <div v-else-if="storeData.approveStatus == 'insufficient'">
                <span class="badge-label rounded-2xl bg-grey fXS">待補件</span>
              </div>
            </div>
          </div>
          <div class="flex justify-end items-center">
            <a @click.prevent="linkClickHandler(merchantApplyUrl)" class="mr-1 border-c1 rounded-2xl primary text-center px-3 py-1 fXS">編輯</a>
          </div>
        </div>
        <div v-else class="record shadow-md mb-3" style="background-color : var(--cWhite); min-height: 162px;"></div>
      </div>

      <div class="records flexV width padding">
        <div>帳務功能</div>
        <div class="grid grid-2 mx-n1">
          <div class="record mt-2 shadow-md mx-1">
            <a @click.prevent="linkClickHandler(ddpayOrderUrl)" class="flexV width center">
              <img src="@/assets/icon/history.svg" width="35" />
              <div>交易紀錄</div>
            </a>
          </div>
          <div class="record mt-2 shadow-md mx-1">
            <a @click.prevent="linkClickHandler(ddpaySalesUrl)" class="flexV width center">
              <img src="@/assets/icon/report.svg" width="35" />
              <div>對賬報表</div>
            </a>
          </div>
        </div>
      </div>

      <div class="records flexV width padding">
        <div>系統設定</div>
        <div class="grid grid-2 mx-n1">
          <div class="record mt-2 shadow-md mx-1">
            <RouterLink :to="'/merchant/permission/' + currentStoreId" class="flexV width center">
              <img src="@/assets/icon/permission.svg" width="32" />
              <div>權限管理</div>
            </RouterLink>
          </div>
          <div v-if="ddpayPaymentApplyEnabled === true" class="record mt-2 shadow-md mx-1">
            <a @click.prevent="linkClickHandler(ddpayPaymentApplyUrl)" class="flexV width center">
              <img src="@/assets/icon/payment-apply.svg" width="35" />
              <div>金流開通</div>
            </a>
          </div>
        </div>
      </div>
    </section>

    <ConfirmDialog
      v-if="showConfirm"
      :initOpen="true"
      :title="confirm.title"
      :content="confirm.message"
      :buttons="confirmDialogButtonConfig"
    />
  </div>
</template>

<script>
import { stores } from "@/services/stores.js";
import { ssourlSeamless } from "@/services/ssourl/src/index.js";
import ConfirmDialog from "@/components/Dialog/ConfirmDialog.vue";

export default {
  components: {
    ConfirmDialog
  },
  data() {
    return {
      latestReadAt: 0,
      storeList: [],
      storeData: null,
      currentStoreId: "0",
      verifyStatus: 'unverified', // unverified, verified
      ssoConfig: {
        merchant: {
          endpoint: process.env.VUE_APP_MGR_CORE_HOST,
          vendorId: process.env.VUE_APP_MGR_CORE_VENDER_ID,
          platformId: process.env.VUE_APP_MGR_CORE_PLATFORM_ID,
          projectId: process.env.VUE_APP_MGR_CORE_PROJECT_ID,
          appId: process.env.VUE_APP_MGR_CORE_APP_ID,
          appSecret: process.env.VUE_APP_MGR_CORE_APP_SECRET,
          replyToken: '',
          shortApiId: process.env.VUE_APP_MGR_CORE_SHORT_API_ID
        },
        ddpay: {
          endpoint: process.env.VUE_APP_MGR_DDPAY_HOST,
          vendorId: process.env.VUE_APP_MGR_DDPAY_VENDER_ID,
          platformId: process.env.VUE_APP_MGR_DDPAY_PLATFORM_ID,
          projectId: process.env.VUE_APP_MGR_DDPAY_PROJECT_ID,
          appId: process.env.VUE_APP_MGR_DDPAY_APP_ID,
          appSecret: process.env.VUE_APP_MGR_DDPAY_APP_SECRET,
          replyToken: '',
          shortApiId: process.env.VUE_APP_MGR_DDPAY_SHORT_API_ID
        }
      },
      ssoRedirectUrls: {
        ddpay: {
          orderUrl: process.env.VUE_APP_MGR_DDPAY_ORDER_URL,
          salesUrl: process.env.VUE_APP_MGR_DDPAY_SALES_URL,
          paymentApplyUrl: process.env.VUE_APP_MGR_DDPAY_PAYMENT_APPLY_URL
        },
        merchant: {
          applyUrl: process.env.VUE_APP_MGR_CORE_MERCHANT_APPLY_URL
        }
      },
      ddpayOrderUrl: '',
      ddpaySalesUrl: '',
      ddpayPaymentApplyUrl: '',
      merchantApplyUrl: '',
      redirectUrl: '',
      showConfirm: false,
      confirm: {
        title: '',
        message: ''
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    // called before the route that renders this component is confirmed.
    // does NOT have access to `this` component instance,
    // because it has not been created yet when this guard is called!
    console.log(to, from);
    next((vm) => {
      let that = vm;
      if (that.user && that.user.userId) {
        //
      } else {
        // window.location.reload();
        next("/home");
      }
    });
  },
  mounted() {
    setTimeout(() => {
      console.log("Notifications", this.notifications);
    }, 4000);

    if (this.user)
    {
      this.fetchStoreList();
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    notifications() {
      let ns = this.$store.getters["noti/notifications"];
      // fake data
      // ns = [{id:1,title:"title1",text:"text1",ts:1720961906,unread:true},{id:2,title:"title2",text:"text2",ts:1720961906,unread:true}];
      return Object.values(ns).sort((a, b) => {
        return b.ts - a.ts;
      });
    },
    confirmDialogButtonConfig() {
      return [
        {
          text: "返回",
          outline: true,
          click: () => {
            this.onCloseConfirmDialog();
          },
        },
        {
          text: "確認",
          click: () => {
            this.onCloseConfirmDialog();

            window.open(this.redirectUrl, '_blank', 'noopener,noreferrer');
          },
        },
      ];
    },
    ddpayPaymentApplyEnabled() {
      return process.env.VUE_APP_MGR_DDPAY_ENABLE_PAYMENT_APPLY === 'true';
    }
  },
  watch: {
    user(value) {
      if (value) {
        this.fetchStoreList();
      }
    },
    storeList(value) {
      let storeId = this.currentStoreId;
      if (this.currentStoreId == 0 && value[0] != undefined && value[0].storeId != undefined)
      {
        storeId = value[0].storeId;
        this.currentStoreId = storeId;
      }
    },
    currentStoreId(value) {
      if (value != 0)
      {
        this.fetchStoreData(value);
        this.$router.push('/merchant?storeId=' + value);
      }
    },
    storeData(value) {
      if (value != null)
      {
        this.generateSSOLink();
      }
    },
    'storeData.shopId'(value) {
      if (value != null && value != '')
      {
        this.verifyStatus = 'verified';
      }
    }
  },
  methods: {
    linkClickHandler(url) {
      this.redirectUrl = url;

      this.confirm = {
        title: '提示',
        message: '您即將離開 App 前往外部連結，請問是否繼續？'
      };

      this.showConfirm = true;
    },
    onCloseConfirmDialog() {
      this.showConfirm = false;

      this.confirm = {
        title: '',
        message: ''
      }
    },
    async fetchStoreList() {
      try
      {
        const res = await stores.getStoreList(this.user.userId);
        this.storeList = stores.useData(res);
      }
      catch (err)
      {
        console.error(err);
        alert('特店列表API暫時無法使用，請稍後再試');
      }
    },
    async fetchStoreData(storeId) {
      try
      {
        const res = await stores.getStoreData(storeId);
        this.storeData = stores.useData(res);
      }
      catch (err)
      {
        console.error(err);
        alert('特店資訊API暫時無法使用，請稍後再試');
      }
    },
    constructNextUrl(endpoint = '', params = {})
    {
      let finalUrl = '';

      try {
        const url = new URL(endpoint);
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));

        finalUrl = url.toString();
      } catch (err) {
        console.error("Error creating URL:", err);
      }

      return finalUrl;
    },
    async generateSSOLink() {
      try
      {
        let nextUrlParams = {};
        
        if (this.storeData.shopId) nextUrlParams['shop-id'] = this.storeData.shopId;

        const userData = {
          userId: this.user.userId,
          userToken: '',
          userName: this.user.displayName,
          userPhone: this.user.phone,
          userEmail: (this.user.user.email ? this.user.user.email : '')
        };
        
        const seamless_ddpay = new ssourlSeamless(this.ssoConfig.ddpay);
          
        this.ddpayOrderUrl = await seamless_ddpay.genurl(this.constructNextUrl(this.ssoRedirectUrls.ddpay.orderUrl, nextUrlParams), userData);
        this.ddpaySalesUrl = await seamless_ddpay.genurl(this.constructNextUrl(this.ssoRedirectUrls.ddpay.salesUrl, nextUrlParams), userData);
        this.ddpayPaymentApplyUrl = await seamless_ddpay.genurl(this.constructNextUrl(this.ssoRedirectUrls.ddpay.paymentApplyUrl, nextUrlParams), userData);

        if (this.storeData.id) nextUrlParams['store_id'] = this.storeData.id;

        const seamless = new ssourlSeamless(this.ssoConfig.merchant);

        this.merchantApplyUrl = await seamless.genurl(this.constructNextUrl(this.ssoRedirectUrls.merchant.applyUrl, nextUrlParams), userData);
      }
      catch (err)
      {
        console.error('Error generating SSO URL:', err);
      }
    }
  },
};
</script>

<style scoped>
.tab {
  border-radius: 0 !important;
}

.record {
  padding: 16px !important;
  margin-top: 12px !important;
}

.items {
  width: 109px;
  padding: 8px !important;
}

button {
  color: white;
  border-radius: 16px !important;
}

.button-outline {
  height: 24px;
  line-height: 21px;
}
</style>

<style src="@/assets/css/app.css"></style>
<style src="@/assets/css/unique.css"></style>
<style scoped src="@/assets/css/payment.css"></style>
